import { ApiProperty } from "@nestjs/swagger";

export class EmployeeByUnitRequest{
  @ApiProperty()
  unitId: number;

  @ApiProperty()
  startDate: any;

  @ApiProperty()
  endDate: any;

  @ApiProperty()
  plant?: any;
  @ApiProperty()
  durationTime?:any

}